'use strict';

module.exports = require('./matrix').Matrix;
module.exports.Decompositions = module.exports.DC = require('./decompositions');



// WEBPACK FOOTER //
// ./node_modules/ml-fnn/node_modules/ml-matrix/src/index.js